import {
  selectGoblinsTrapDeathHexKeys,
  selectHexes,
  selectPlayers,
  selectUnits
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {calculateAvailableMovementCells} from "../calculateAvailableMovementCells";
import {checkIfUnitMovementProcessed} from "./checkIfUnitProcessed";
import {checkIfUnitCanSteal} from "./checkIfUnitCanSteal";
import {getGridGeometry} from "./getGridGeometry";

/**
 * Может ли отряд игрока действовать на этапе перемещения: еще не обработан и
 * либо может украсть (Лепреконы), либо у него есть ячейка в пределах дальности,
 * в том числе ячейка за дополнительное снабжение. Сначала дешевые отсечки,
 * поиск ячеек — последним. Поле берется из геометрии без рендерера.
 */
export const checkIfUnitCanMove = (state, unit, player) => {
  if (unit.ownerId !== player.id || checkIfUnitMovementProcessed(state, unit)) {
    return false;
  }
  if (checkIfUnitCanSteal(state, unit, player)) {
    return true;
  }

  const {cells} = calculateAvailableMovementCells(
    getGridGeometry(state),
    selectHexes(state),
    selectUnits(state),
    unit,
    selectPlayers(state),
    selectGoblinsTrapDeathHexKeys(state)
  );
  return cells.length > 0;
};
